import React from "react";
import { Col, Container, Row } from "react-bootstrap";

const aboutStyles = {
  container: {
    backgroundColor: "#0a2351",
    color: "white",
  },
  heading: {
    marginTop: "2rem",
    marginBottom: "2rem",
    marginLeft: "0.5rem",
  },
  valuesText: {
    textUnderlineOffset: "15px",
    marginBottom: "25px",
  },
  hr: {
    width: "100%",
    maxWidth: "400px",
    borderTop: "3px solid white",
    margin: "10px 0",
  },
};

const About = () => {
  return (
    <Container fluid style={aboutStyles.container}>
      <Row>
        <div style={aboutStyles.heading}>
          <h3 className="display-6">About Us</h3>
        </div>
      </Row>
      <Row>
        <Col sm={6} lg={7}>
          <div className="mb-5 ms-2">
            <h4 className="mb-4">Our Values</h4>
            <p className="hover-right" style={aboutStyles.valuesText}>
              Customer-centric approach, always striving for their success.
            </p>
            <hr style={aboutStyles.hr}/>
            <p className="hover-right" style={aboutStyles.valuesText}>
              Collaboration and trust as the foundation of our work.
            </p>
            <hr style={aboutStyles.hr}/>
            <p className="hover-right" style={aboutStyles.valuesText}>
              Excellence through innovation, precision, and consistency.
            </p>
            <hr style={aboutStyles.hr} />
            <p className="hover-right" style={aboutStyles.valuesText}>Passionate about delivering excellence in every project.</p>
            <hr style={aboutStyles.hr} />
          </div>
        </Col>
        <Col sm={6} lg={{ span: 3, offset: 1 }}>
          <div className="me-4 mb-5">
            <h4 className="mb-4">Our Business Focus</h4>
            <p>
              IDM 360 Analytics is an Indian based Information Security Solutions
              and Service provider. Our mission is to deliver secure, scalable, and efficient 
	      IAM solutions, ensuring Data protection and Compliance.
	      We focus on Mitigating risks, Improving operational efficiency, and enabling robust Identity governance for a Secure Digital Landscape.
            </p>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default About;
